export const list=[{
    h1:"Support",
    
point:["Help Centre",
"AirCover",
"Supporting people with disabipointties",
"Cancellation options",
"Our COVID-19 Response",
"Report a neighbourhood concern"]
},{
    h1:"Community",
    
    point:["HouseHive.org: disaster repointef housing",
        "Combating discrimination"]
},
{
    h1:"Hosting",
    
    point:["HouseHive your home",
       "AirCover for Hosts",
      "Explore hosting resources",
        "Visit our community forum",
        "How to host responsibly"]  
},{
    h1:"HouseHive",
    point:[
       "Newsroom",
"learn about new features",
"Letter from our founders",
"Careers",
"Investors"
    ]
}]